import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum ViewByEnum {
  ORDER_DATE = "orderDate",
  PROCESSED_DATE = "processedDate",
  SUBMITTED_DATE = "submittedDate",
}

export const ViewByToggleSchema = createEnum([
  ViewByEnum.ORDER_DATE,
  ViewByEnum.PROCESSED_DATE,
  ViewByEnum.SUBMITTED_DATE,
]);

export type ViewByToggleType = z.infer<typeof ViewByToggleSchema>;
